<template>
  <div>
    <page-header>
      <template #title>
        <h1 class="page-title" v-text="pageTitle"></h1>
      </template>
    </page-header>
    <div class="row">
      <div class="col-lg-12">
        <div class="card mb-3">
          <div class="card-body">
            <div class="col-lg-6">
              <fieldset>
                <legend>Tyre Tread</legend>
                <inputbox
                  v-model="form.front_left_tread"
                  name="front_left_tread"
                  label="Front Left Tread (mm)"
                  :required="true"
                  :error-message="form.errors.get('front_left_tread')"
                  helper="Please enter the tyre tread depth in mm."
                  :show-error="form.errors.has('front_left_tread')"
                ></inputbox>
                <inputbox
                  v-model="form.front_right_tread"
                  name="front_right_tread"
                  label="Front Right Tread (mm)"
                  :required="true"
                  :error-message="form.errors.get('front_right_tread')"
                  helper="Please enter the tyre tread depth in mm."
                  :show-error="form.errors.has('front_right_tread')"
                ></inputbox>
                <inputbox
                  v-model="form.rear_left_tread"
                  name="rear_left_tread"
                  label="Rear Left Tread (mm)"
                  :required="true"
                  :error-message="form.errors.get('rear_left_tread')"
                  helper="Please enter the tyre tread depth in mm."
                  :show-error="form.errors.has('rear_left_tread')"
                ></inputbox>
                <inputbox
                  v-model="form.rear_right_tread"
                  name="rear_right_tread"
                  label="Rear Right Tread (mm)"
                  :required="true"
                  :error-message="form.errors.get('rear_right_tread')"
                  helper="Please enter the tyre tread depth in mm."
                  :show-error="form.errors.has('rear_right_tread')"
                ></inputbox>
              </fieldset>
            </div>
            <div class="col-lg-6">
              <fieldset>
                <legend>Service Details</legend>
                <div
                  class="form-group has-helper"
                  :class="{ 'has-error': form.errors.has('serviced_at') }"
                >
                  <div class="col-md-4">
                    <label for="serviced_at" class="control-label"
                      >Service Date:*</label
                    >
                    <p class="help-block">
                      Please enter the date this service was carried out.
                    </p>
                  </div>
                  <div class="col-md-8">
                    <datepicker
                      format="dd/MM/yyyy"
                      :value="form.serviced_at"
                      v-on:selected="setServicedDate"
                      input-class="form-control"
                      placeholder="dd/mm/yyyy"
                      :disabled="disabledDates"
                    ></datepicker>
                    <span
                      class="text-danger"
                      v-text="form.errors.get('serviced_at')"
                      v-if="form.errors.has('serviced_at')"
                    ></span>
                  </div>
                </div>
                <div
                  class="form-group has-helper"
                  :class="{ 'has-error': form.errors.has('next_service_at') }"
                >
                  <div class="col-md-4">
                    <label for="next_service_at" class="control-label"
                      >Next Service Date:*</label
                    >
                    <p class="help-block">
                      Please enter the date the next service is due.
                    </p>
                  </div>
                  <div class="col-md-8">
                    <datepicker
                      format="dd/MM/yyyy"
                      :value="form.next_service_at"
                      v-on:selected="setNextServiceAtDate"
                      input-class="form-control"
                      placeholder="dd/mm/yyyy"
                      :disabled="disabledDates"
                    ></datepicker>
                    <span
                      class="text-danger"
                      v-text="form.errors.get('next_service_at')"
                      v-if="form.errors.has('next_service_at')"
                    ></span>
                  </div>
                </div>
                <inputbox
                  v-model="form.mileage"
                  name="mileage"
                  label="Mileage"
                  :required="true"
                  :error-message="form.errors.get('mileage')"
                  helper="Please enter the mileage that was recorded for this service."
                  :show-error="form.errors.has('mileage')"
                ></inputbox>

                <input-block
                  name="description"
                  label="Notes"
                  v-model="form.description"
                  helper="If there is anything important to note about the service, enter that here."
                ></input-block>
              </fieldset>
            </div>
          </div>
          <div class="card-footer text-right">
            <button
              class="btn btn-primary btn-raised"
              name="save"
              v-on:click.prevent="submit"
            >
              <i class="icon icon-save"></i> Save
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from './../../Shared/PageHeader.vue';

export default {
  components: {
    PageHeader
  },

  props: {
    identifier: {
      type: String,
      required: true
    },
    service: {
      type: String
    }
  },

  data() {
    return {
      form: new window.Form({
        mileage: null,
        front_left_tread: null,
        front_right_tread: null,
        rear_left_tread: null,
        rear_right_tread: null,
        description: null,
        serviced_at: window.DateManager.format(new Date(), 'YYYY-MM-DD'),
        next_service_at: window.DateManager.format(
          window.DateManager.addYear(new Date()),
          'YYYY-MM-DD'
        )
      })
    };
  },

  computed: {
    disabledDates() {
      let date = new Date();
      date.setDate(date.getDate() - 1);

      return { to: date };
    },

    pageTitle() {
      if (this.service) {
        return 'Update Service';
      }

      return 'Add Service';
    }
  },

  mounted() {
    if (this.service) {
      let identifier = this.$store.getters.user.tenant.identifier;

      window.Ajax.get(
        `/fleet/${identifier}/${this.identifier}/services/${this.service}`
      )
        .then(response => {
          this.form.mileage = response.data.mileage;
          this.form.description = response.data.description;
          this.form.front_left_tread = parseFloat(
            response.data.front_left_tread
          ).toFixed(2);
          this.form.front_right_tread = parseFloat(
            response.data.front_right_tread
          ).toFixed(2);
          this.form.rear_left_tread = parseFloat(
            response.data.rear_left_tread
          ).toFixed(2);
          this.form.rear_right_tread = parseFloat(
            response.data.rear_right_tread
          ).toFixed(2);
          this.form.serviced_at = window.DateManager.parse(
            response.data.serviced_at
          );
          this.form.next_service_at = window.DateManager.format(
            response.data.next_service_at,
            'YYYY-MM-DD'
          );
        })
        .catch(error => {});
    }
  },

  methods: {
    submit() {
      let identifier = this.$store.getters.user.tenant.identifier;
      let url = `/fleet/${identifier}/${this.identifier}/services`;
      let method = 'post';

      if (this.service) {
        url += `/${this.service}`;
        method = 'put';
      }

      this.form[method](url)
        .then(response => {
          window.toastify.success(
            'Success!',
            'The service was added successfully!'
          );
          this.$router.back();
        })
        .catch(error => {
          window.toastify.error(
            'Error',
            'There was an error saving the service.'
          );
        });
    },

    setNextServiceAtDate(value) {
      this.form.next_service_at = value;
    },

    setServicedDate(value) {
      this.form.serviced_at = value;
    }
  }
};
</script>
